// extracted by mini-css-extract-plugin
module.exports = {"formTitle":"CompanyIntro_formTitle__1b78V"};